import { render, staticRenderFns } from "./public-leagues.vue?vue&type=template&id=db470d76&"
import script from "./public-leagues.vue?vue&type=script&lang=js&"
export * from "./public-leagues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports